import {DeviceType} from "../enum/DeviceType";
import {getLoading} from "./loading";
import {DEFAULT_LANGUAGE, isSupportedLanguage} from "../const/Language";

export function isIOSCheck () {
    let u = navigator.userAgent;
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || !!u.match(/(iPad|iPhone|iPod|Macintosh)/);
    return isIOS;
}

//获取网页宽度
export const getBrowserWidth = () => {
    if (window.innerWidth) {
        return window.innerWidth;
    } else if (document.body && document.body.clientWidth) {
        return document.body.clientWidth;
    } else {
        return 0;
    }
}
export const isMobile = () => {
    if (getBrowserWidth() < 981) {
        return true;
    }
    return false;
}

export const getThinUuid = () => {
    const temp_url = URL.createObjectURL(new Blob());
    const uuid = temp_url.toString();
    URL.revokeObjectURL(temp_url);
    return uuid
      .substr(uuid.lastIndexOf("/") + 1)
      .replaceAll("-", "")
      .toUpperCase();
  };

export const formatCheeseName = (kebabCaseString, join = " ") => {
    if (typeof kebabCaseString !== 'string' || kebabCaseString.length === 0) {
        return '';
    }
    const withSpaces = kebabCaseString.replace(/-|_/g, ' ');
    const words = withSpaces.split(' ');
    const formattedWords = words.map(word => {
        if (word.length === 0) {
            return '';
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return formattedWords.join(join);
}
/**
 * 将驼峰命名 (camelCase) 字符串转换为下划线命名 (snake_case) 字符串。
 * 例如：'firstName' -> 'first_name'
 *       'userNameId' -> 'user_name_id'
 *       'HTTPResponse' -> 'http_response'
 *
 * @param {string} camelCaseStr - 驼峰命名字符串。
 * @returns {string} 下划线命名字符串。
 */
export const camelToSnakeCase = (camelCaseStr) => {
    if (typeof camelCaseStr !== 'string' || camelCaseStr.length === 0) {
        return '';
    }

    // 使用正则表达式匹配所有大写字母，并在其前添加下划线，然后转小写
    // $1 表示匹配到的第一个捕获组，即大写字母
    return camelCaseStr.replace(/[A-Z]/g, (match, offset) => {
        // 如果是大写字母，且不是字符串的第一个字符，则在其前面添加下划线
        return (offset > 0 ? '_' : '') + match.toLowerCase();
    });

    // 另一种更简洁的写法 (但会处理首字母，如果首字母是大写会变成 "_x"):
    // return camelCaseStr.replace(/([A-Z])/g, "_$1").toLowerCase();
    // 因此，上面的写法更安全，因为它避免了首字母大写时生成前导下划线。
};
/**
 * 将下划线命名 (snake_case) 字符串转换为驼峰命名 (camelCase) 字符串。
 * 例如：'first_name' -> 'firstName'
 *       'user_name_id' -> 'userNameId'
 *       'http_response' -> 'httpResponse'
 *
 * @param {string} snakeCaseStr - 下划线命名字符串。
 * @param {boolean} [capitalizeFirstLetter=false] - 是否将首字母大写（转为 PascalCase）。
 * @returns {string} 驼峰命名字符串。
 */
export const snakeToCamelCase = (snakeCaseStr, capitalizeFirstLetter = false) => {
    if (typeof snakeCaseStr !== 'string' || snakeCaseStr.length === 0) {
        return '';
    }

    // 匹配下划线后面跟着一个字母的模式
    const camelCase = snakeCaseStr.replace(/_([a-z])/g, (match, char) => {
        return char.toUpperCase();
    });

    // 处理首字母大小写
    if (capitalizeFirstLetter) {
        // 如果需要大驼峰 (PascalCase)，将第一个字母大写
        return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
    } else {
        // 默认是小驼峰 (camelCase)，将第一个字母小写
        return camelCase.charAt(0).toLowerCase() + camelCase.slice(1);
    }
};

export const isValidEmail = (email) => {
    // 移除首尾空白
    email = email.trim();

    // 邮件正则表达式
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emailRegex.test(email);
}
export const hasIntersectionUsingSet = (arr1, arr2) => {
    // 为了优化性能，通常将较小的数组转换为 Set
    const set1 = new Set(arr1);

    for (const element of arr2) {
        if (set1.has(element)) {
            return true;
        }
    }

    return false;
}

/**
 * 根据健康问题获取不推荐的饮食偏好列表
 * @param {Array} healthConcerns - 用户的健康问题列表
 * @returns {Array} 不推荐的饮食偏好列表（如 ['Keto', 'High protein', 'Paleo', 'Vegan']）
 */
export const getNotRecommendedDietaryPreferences = (healthConcerns) => {
    if (!healthConcerns || healthConcerns.length === 0) {
        return [];
    }

    const notRecommended = new Set();

    // 1. Hypertension, High Cholesterol, Diabetes, Heart Disease → Keto, High protein
    if (hasIntersectionUsingSet(healthConcerns, ["Hypertension", "High cholesterol", "Diabetes", "Heart disease"])) {
        notRecommended.add("Keto");
        notRecommended.add("High protein");
    }

    // 2. Obesity, Thyroid Disease → Keto
    if (hasIntersectionUsingSet(healthConcerns, ["Obesity", "Thyroid disease"])) {
        notRecommended.add("Keto");
    }

    // 3. Kidney Disease → Keto, High protein, Paleo, Vegan
    if (hasIntersectionUsingSet(healthConcerns, ["Kidney disease"])) {
        notRecommended.add("Keto");
        notRecommended.add("High protein");
        notRecommended.add("Paleo");
        notRecommended.add("Vegan");
    }

    // 4. Gastric Disease → Paleo
    if (hasIntersectionUsingSet(healthConcerns, ["Gastric disease"])) {
        notRecommended.add("Paleo");
    }

    return Array.from(notRecommended);
}


//将599转成09.59
/**
 * 将总秒数转换为 "MM:SS" 格式的时间字符串。
 * 例如：599 秒 转换为 "09:59"
 *
 * @param {number | string} totalSecondsValue - 需要转换的总秒数。
 * @returns {string} 格式化后的时间字符串 (例如: "09:59"), 如果输入无效则返回空字符串。
 */
export const toTimestamp = (totalSecondsValue) => {
    if (totalSecondsValue === null || totalSecondsValue === undefined || totalSecondsValue === '') {
        return '';
    }

    const totalSeconds = Number(totalSecondsValue);

    if (isNaN(totalSeconds) || totalSeconds < 0) {
        return '';
    }

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
};


export const objToFormData = (obj) => {
    const params = new URLSearchParams();
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            params.append(key, obj[key]);
        }
    }
    return params.toString();
}

/**
 * 生成支付页面图片名称
 * 根据性别、体型和年龄生成对应的图片文件名
 * @param {string} gender - 性别 ('male' 或 'female')
 * @param {string} bodyType - 体型类型
 * @param {string|number} age - 年龄
 * @returns {string} 图片文件名
 */
export const generatePayImageName = (gender, bodyType, age) => {
    const formattedGender = formatCheeseName(gender);
    const formattedBodyType = formatCheeseName(bodyType, "");
    
    // 如果是女性且年龄大于等于45岁，添加年龄后缀
    if (gender === 'female' && age && parseInt(age) >= 45) {
        return `Pay${formattedGender}${formattedBodyType}45@3.png`;
    }
    
    // 默认格式
    return `Pay${formattedGender}${formattedBodyType}@3.png`;
}

/**
 * 检测是否为iOS设备
 * @returns {boolean} 是否为iOS设备
 */
export const isIOSDevice = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
           (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

const isIPAD = () => {
    return (
        /Macintosh/i.test(navigator.userAgent) &&
        navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 1
    );
};
const isStrictlyIOS = () => {
    if (isIPAD()) {
        return true;
    }
    return getEventDeviceType() === DeviceType.IOS;
}

export const getDeviceTypeCodeByBrowser = () => {
    if (isStrictlyIOS()) {
        return "ios";
    }
    if (getEventDeviceType() === DeviceType.ANDROID) {
        return 'android';
    }
    return "pc";
}
export const getEventDeviceType = () => {
    if (isIPAD()) {
        return DeviceType.IOS;
    }

    let userAgent = navigator.userAgent.toLowerCase();
    if (/(iPhone|iPad|iPod|iOS)/i.test(userAgent) || isIPAD()) {
        return DeviceType.IOS;
    } else if (/(Android)/i.test(userAgent)) {
        return DeviceType.ANDROID;
    } else {
        return DeviceType.WEB;
    }
};

export function getQueryString(name) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const r = window.location.search.substr(1).match(reg);
    if (r !== null) return decodeURI(r[2]);
    return null;
}

export function relocateToPage(path) {
    const loading = getLoading();
    loading.show();

    const targetPath = buildLocalizedPath(path);
    
    // Handle query string correctly
    const currentSearch = window.location.search;
    if (currentSearch) {
        // If path already has query string, use & to append
        // Otherwise use ? to append
        const separator = targetPath.includes('?') ? '&' : '?';
        window.location.href = targetPath + separator + currentSearch.substring(1);
    } else {
        window.location.href = targetPath;
    }
}

export const getLanguagePathPrefix = (pathname = window.location.pathname) => {
    const [firstSegment = ""] = pathname.split("/").filter(Boolean);
    if (!firstSegment || !isSupportedLanguage(firstSegment) || firstSegment === DEFAULT_LANGUAGE) {
        return "";
    }
    return `/${firstSegment}`;
};

export const buildLocalizedPath = (path, pathname = window.location.pathname) => {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${getLanguagePathPrefix(pathname)}${normalizedPath}`;
};


// load script by url
export async function loadScript(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.rel = "nofollow";
    script.src = url;
    document.head.appendChild(script);
    script.onload = function(e){
        callback();
    }
}

export async function loadJavaScript(url) {
    return new Promise((resolve, reject) => {
        loadScript(url, () => {
            resolve();
        });
    });
}

// ==================== 单位转换工具函数 ====================

// Height单位转换常量
const FEET_TO_CM_FACTOR = 30.48;
const CM_TO_FEET_FACTOR = 0.0328084;

// Weight单位转换常量
const LBS_TO_KG_FACTOR = 0.453592;
const KG_TO_LBS_FACTOR = 2.20462;

/**
 * Height单位转换
 * @param {string|number} value - 要转换的值
 * @param {string} fromUnit - 源单位 ('ft' 或 'cm')
 * @param {string} toUnit - 目标单位 ('ft' 或 'cm')
 * @returns {string} 转换后的值（保留1位小数）
 */
export const convertHeight = (value, fromUnit, toUnit) => {
    if (!value || isNaN(value)) return "";
    
    const numValue = parseFloat(value);
    if (fromUnit === "ft" && toUnit === "cm") {
        // 英尺转厘米：1英尺 = 30.48厘米
        return (numValue * FEET_TO_CM_FACTOR).toFixed(1);
    } else if (fromUnit === "cm" && toUnit === "ft") {
        // 厘米转英尺：1厘米 = 0.0328084英尺
        return (numValue * CM_TO_FEET_FACTOR).toFixed(1);
    }
    return value.toString();
};

/**
 * Weight单位转换
 * @param {string|number} value - 要转换的值
 * @param {string} fromUnit - 源单位 ('lbs' 或 'kg')
 * @param {string} toUnit - 目标单位 ('lbs' 或 'kg')
 * @returns {string} 转换后的值（保留2位小数）
 */
export const convertWeight = (value, fromUnit, toUnit) => {
    if (!value || isNaN(value)) return "";
    
    const numValue = parseFloat(value);
    if (fromUnit === "lbs" && toUnit === "kg") {
        // 磅转千克：1磅 = 0.453592千克
        return (numValue * LBS_TO_KG_FACTOR).toFixed(2);
    } else if (fromUnit === "kg" && toUnit === "lbs") {
        // 千克转磅：1千克 = 2.20462磅
        return (numValue * KG_TO_LBS_FACTOR).toFixed(2);
    }
    return value.toString();
};

/**
 * 根据Height单位推导Weight单位
 * @param {string} heightUnit - Height单位 ('ft' 或 'cm')
 * @returns {string} 对应的Weight单位 ('lbs' 或 'kg')
 */
export const getWeightUnitFromHeight = (heightUnit) => {
    return heightUnit === "ft" ? "lbs" : "kg";
};
